<template>
  <div class="font-amharic">
    <span class="text-gray-700">Destination Address</span>
    <input
      type="text"
      class="form-input mt-1 w-full block"
      placeholder="Enter a Destination Location"
      @keyup="search"
      v-model="label"
    />
    <ul
      v-if="results.length"
      class="absolute max-h-56 mt-1 bg-white border rounded shadow overflow-y-auto"
    >
      <li
        v-for="(result, index) in results"
        :key="`pickadd-${index}`"
        class="px-3 py-2 cursor-pointer hover:bg-blue-500 hover:text-white"
        @click="select(index)"
      >
        {{ result.structured_formatting.main_text }},
        {{ result.structured_formatting.secondary_text }}
      </li>
    </ul>
  </div>
</template>

<script>
import _ from "lodash";
import init from "@/gmaps";

export default {
  data() {
    return {
      label: "",
      results: [],
      mapsService: null,
      google: null
    };
  },
  async mounted() {
    try {
      this.google = await init();
      this.mapsService = new this.google.maps.places.AutocompleteService();
    } catch (error) {
      console.error("KEBAD ERROR", error);
    }

    window.events.$on("dispatched", () => (this.label = ""));
  },
  methods: {
    select(index) {
      let result = this.results[index];
      this.label =
        result.structured_formatting.main_text +
        ", " +
        result.structured_formatting.secondary_text;
      this.$emit("input", {
        place_id: result.place_id,
        name: result.description
      });
      this.results = [];
    },
    search: _.debounce(function(e) {
      if (!this.mapsService || e.target.value.trim() == "") {
        this.results = [];
        return false;
      }

      this.mapsService.getQueryPredictions(
        {
          input: e.target.value,
          location: new this.google.maps.LatLng(8.9806034, 38.7577605),
          radius: 20000
        },
        (predictions, status) => {
          if (status !== this.google.maps.places.PlacesServiceStatus.OK) {
            return;
          }

          this.results = predictions;
        }
      );
    }, 500)
  }
};
</script>
